import type { NormalizeOAS, OASModel } from 'fets';
import type openapi from '../../../rest-api/openapi';
import { ApiClient } from '../../../rest-api/fetsClient';
import { throwIfNotOk } from '../../../rest-api/throwIfNotOk';

export type CourseExportLink = OASModel<NormalizeOAS<typeof openapi>, 'CourseExportLinkListingItem'>;

export const createCourseExportLinksApi = (apiClient: ApiClient) => {
  const createCourseExportLink = async (courseExportGuid: string) => {
    const response = await apiClient['/api/course-exports/{courseExportGuid}/links'].post({
      params: { courseExportGuid },
    });
    await throwIfNotOk(response, 'create the link');
    const data = await response.json();
    return { guid: data.guid, slug: data.slug, isActive: data.isActive };
  };

  const setCourseExportLinkActive = async (variables: { linkGuid: string; isActive: boolean }) => {
    const response = await apiClient['/api/course-exports/links/{linkGuid}'].put({
      params: { linkGuid: variables.linkGuid },
      json: { isActive: variables.isActive },
    });
    await throwIfNotOk(response, variables.isActive ? 'activate the link' : 'deactivate the link');
    return variables;
  };

  const deleteCourseExportLink = async (linkGuid: string) => {
    const response = await apiClient['/api/course-exports/links/{linkGuid}'].delete({ params: { linkGuid } });
    await throwIfNotOk(response, 'delete the link');
    return linkGuid;
  };

  return { createCourseExportLink, setCourseExportLinkActive, deleteCourseExportLink };
};
